import { render, staticRenderFns } from "./SelectShareFolderDialogue.vue?vue&type=template&id=1b20ac1d&scoped=true&"
import script from "./SelectShareFolderDialogue.vue?vue&type=script&lang=js&"
export * from "./SelectShareFolderDialogue.vue?vue&type=script&lang=js&"
import style0 from "./SelectShareFolderDialogue.vue?vue&type=style&index=0&id=1b20ac1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20ac1d",
  null
  
)

export default component.exports